export const reCaptcha = (() => {
    var element = document.querySelector('[data-submit-recaptcha]');

    if (element != null) {
        element.addEventListener('click', function (event) {
            event.preventDefault();

            var tokenInput = document.getElementById("token");
            var tokenForm = document.getElementById("tokenForm");

            if (!tokenInput || !tokenForm) {
                return;
            }

            // Check if reCAPTCHA is available (production) or if we're in development mode
            if (typeof grecaptcha !== 'undefined') {
                var sitekey = element.getAttribute('data-sitekey');
                grecaptcha.ready(function () {
                    grecaptcha.execute(sitekey, { action: 'submit' }).then(function (token) {
                        tokenInput.value = token;
                        tokenForm.submit();
                    });
                });
            } else {
                // Development mode - submit directly without reCAPTCHA token
                tokenInput.value = 'dev-bypass-token';
                tokenForm.submit();
            }
        });
    }

})();
